import { Expose } from 'class-transformer';
import { Model } from "../../../shared/models/model";

export class AvlOverSpeed extends Model {
  @Expose() deviceId: number;
  @Expose() deviceName: string;
  @Expose() speed: number;
  @Expose() latitude: number;
  @Expose() longitude: number;
}
